/* Native footer disclosures stay expanded outside the phone layout. */
if (!customElements.get('objectiv-footer')) {
  customElements.define('objectiv-footer', class extends HTMLElement {
    connectedCallback() {
      if (this.lifetime) return;
      this.lifetime = new AbortController();
      this.groups = [...this.querySelectorAll('[data-footer-group]')];
      this.mobile = matchMedia('(max-width: 749px), (max-width: 989px) and (max-height: 500px)');
      const options = {signal: this.lifetime.signal};
      this.mobile.addEventListener('change', () => this.syncLayout(), options);
      this.addEventListener('click', event => {
        if (!this.mobile.matches && event.target.closest('[data-footer-group] > summary')) event.preventDefault();
      }, options);
      this.syncLayout();
    }

    syncLayout() {
      for (const group of this.groups) {
        const summary = group.querySelector('summary');
        if (this.mobile.matches) {
          summary.removeAttribute('tabindex');
          if (group.contains(document.activeElement) && document.activeElement !== summary) summary.focus({preventScroll: true});
        } else {
          summary.setAttribute('tabindex', '-1');
        }
        group.open = !this.mobile.matches;
      }
    }

    disconnectedCallback() {
      this.lifetime?.abort();
      this.lifetime = null;
    }
  });
}
